module.exports = __webpack_public_path__ + "img/46.85f5bd71.jpg";